var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#000000;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304,309.328V360h-96v-50.672H0v117.344c0,35.344,28.656,64,64,64h384c35.344,0,64-28.656,64-64V309.328H304z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372,69.328c0,8.844-7.406,16-16.563,16H156.578c-9.156,0-16.578-7.156-16.578-16v-32 c0-8.828,7.422-16,16.578-16h198.859c9.156,0,16.563,7.172,16.563,16V69.328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.656,185.328c0,8.844-7.156,16-16,16h-1.328c-8.828,0-16-7.156-16-16V120c0-8.844,7.172-16,16-16h1.328 c8.844,0,16,7.156,16,16V185.328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.656,185.328c0,8.844-7.156,16-16,16h-1.328c-8.828,0-16-7.156-16-16V120c0-8.844,7.172-16,16-16h1.328 c8.844,0,16,7.156,16,16V185.328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448,154.672H64c-35.344,0-64,28.656-64,64v58.656h208V232h96v45.328h208v-58.656 C512,183.328,483.344,154.672,448,154.672z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 248,
    className: "st0",
    width: 64,
    height: 96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.27d369123999a69860a16b3a295bfd4b.svg";
export { ForwardRef as ReactComponent };